import client from "../../../api/client";

export default async function completeUserProfile(payload) {
    const response = await client.post("/user/complete-user-profile", payload);
    return response.data;
}